'use client';

import { ModalBase as CommonModalBase, type ModalBaseProps } from '@monorepo/common';

function ModalBase(props: Omit<ModalBaseProps, 'variant'>) {
  return <CommonModalBase {...props} />;
}

export default ModalBase;
